import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.5.5c-3.314 0-6 2.239-6 5 0 1.021.369 1.97 1 2.762V12l2.573-1.93a6.98 6.98 0 002.427.43c3.314 0 6-2.239 6-5s-2.686-5-6-5z",
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.219 12.504C6.308 13.427 7.824 14 9.499 14c.784 0 1.53-.13 2.216-.356L14.5 15.5v-3.738c.63-.792 1-1.74 1-2.762a4.36 4.36 0 00-.8-2.495",
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }